<script>
import { ShowCardSmallElementMixin } from "%/dynamic-component-editor/standard-components/show-card-small/show-card-small-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "ShowType",
  elementPanelSettings: {
    displayName: "Type",
    displayIcon: "text-alt",
    elementGroup: "show",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [ShowCardSmallElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.entity.type;
    },
  },
};
</script>

